import React from 'react';
import PropTypes from 'prop-types';
import {
  useLoungeName,
  useLoungeProviderId,
} from '@/hooks/loungesHooks/loungesHelperHooks';
import { cn } from '@/helpers/utils';

const LoungeTermsContent = ({ loungeId, partners, textCustomStyles }) => {
  const providerId = useLoungeProviderId(loungeId);
  const loungeName = useLoungeName(loungeId);

  // wonky provider property in lounge data and partners data array - provider_id is set to priority pass for lufthansa
  const providerFilterCallback = (partner) => {
    if (partner?.provider_id?.includes(providerId)) {
      return !(
        providerId === 'PROVIDER_PRIORITY_PASS' &&
        loungeName.toLowerCase().includes('lufthansa')
      );
    }
    if (
      partner?.provider_id === 'PROVIDER_LUFTHANSA' &&
      loungeName.toLowerCase().includes('lufthansa')
    ) {
      return true;
    }
    if (
      !partner?.provider_id &&
      loungeName.toLowerCase().includes('eurostar')
    ) {
      return true;
    }
    return false;
  };

  const partnersWithProviderId = partners.filter((partner) =>
    providerFilterCallback(partner)
  );

  const filteredPartners =
    providerId && partnersWithProviderId.length > 0
      ? partnersWithProviderId
      : partners;

  return (
    <>
      {filteredPartners.map(({ partner_name: partnerName, terms }) => (
        <React.Fragment key={partnerName}>
          <h3
            className={cn('tw-text-xs tw-font-bold', textCustomStyles)}
            data-testid="partner-name"
          >
            {partnerName}
          </h3>
          <p
            className={cn(
              'margin-2-b tw-text-xs a-children_tw-underline focus_a-children_tw-text-blue-bright-600',
              textCustomStyles
            )}
            dangerouslySetInnerHTML={{ __html: terms }}
          />
        </React.Fragment>
      ))}
    </>
  );
};

LoungeTermsContent.propTypes = {
  loungeId: PropTypes.string.isRequired,
  partners: PropTypes.arrayOf(
    PropTypes.shape({
      partner_name: PropTypes.string,
      provider_id: PropTypes.string,
      logo: PropTypes.string,
      link_label: PropTypes.string,
      link_URL: PropTypes.string,
      terms: PropTypes.string,
      order: PropTypes.number,
    })
  ).isRequired,
  textCustomStyles: PropTypes.string,
};

export default LoungeTermsContent;
